(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2724],{

/***/ 61196:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recuperar-contrasena",
      function () {
        return __webpack_require__(50477);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 50477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4351);
/* harmony import */ var ab_forgot_password__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4302);




var ForgotPassword = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var i18n = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common").i18n;
    // console.log("ForgotPassword", router.query.key);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_forgot_password__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        resetKey: router.query.key,
        user: router.query.id,
        i18n: i18n
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ForgotPassword);


/***/ }),

/***/ 4302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62062);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92151);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68301);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var ab_text__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(145);
/* harmony import */ var ab_input__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9215);
/* harmony import */ var ab_api_mutations__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(53549);
/* harmony import */ var ab_form_button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81402);
/* harmony import */ var _ab_forgot_password_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70996);
/* harmony import */ var _ab_forgot_password_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_ab_forgot_password_scss__WEBPACK_IMPORTED_MODULE_9__);











var ForgotPassword = function(param) {
    var formTitle = param.formTitle, emailPlaceholder = param.emailPlaceholder, resetKey = param.resetKey, i18n = param.i18n, user = param.user;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)("common", {
        i18n: i18n
    }).t;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), error = ref[0], setError = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isSent = ref2[0], setIsSent = ref2[1];
    var formik = (0,formik__WEBPACK_IMPORTED_MODULE_10__/* .useFormik */ .TA)({
        enableReinitialize: true,
        validateOnChange: false,
        validateOnBlur: true,
        initialValues: {
            email: "",
            key: !!resetKey,
            password: "",
            passwordConfirm: ""
        },
        validationSchema: yup__WEBPACK_IMPORTED_MODULE_3__/* .object */ .Ry().shape({
            email: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_().email().when("key", {
                is: false,
                then: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_().required(t("validationEmail"))
            }),
            password: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_().when("key", {
                is: true,
                then: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_().required(t("validationPassword")).matches(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/, t("validationPasswordFormat"))
            }),
            passwordConfirm: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_().when("key", {
                is: true,
                then: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_().oneOf([
                    yup__WEBPACK_IMPORTED_MODULE_3__/* .ref */ .iH("password"),
                    null
                ], t("validationPasswordConfirm")).required(t("validationPassword"))
            })
        }),
        onSubmit: function(values, param) {
            var resetForm = param.resetForm;
            setLoading(true);
            if (resetKey) {
                (0,ab_api_mutations__WEBPACK_IMPORTED_MODULE_7__/* .resetUserPassword */ .h8)(user, resetKey, values.password).then(function(res) {
                    // console.log("loginresult", res);
                    // if (
                    //   res?.[0]?.message ===
                    //   "There is no user registered with that email address."
                    // ) {
                    //   setError("No existe un usuario registrado con ese email.");
                    // }
                    setLoading(false);
                    next_router__WEBPACK_IMPORTED_MODULE_4___default().push("/login");
                });
            } else {
                (0,ab_api_mutations__WEBPACK_IMPORTED_MODULE_7__/* .sendPasswordResetEmail */ .LS)(values.email).then(function(res) {
                    var ref;
                    // console.log("loginresult", res);
                    if ((res === null || res === void 0 ? void 0 : (ref = res[0]) === null || ref === void 0 ? void 0 : ref.message) === "There is no user registered with that email address.") {
                        var ref1;
                        setError((i18n === null || i18n === void 0 ? void 0 : i18n.language) == "en" ? res === null || res === void 0 ? void 0 : (ref1 = res[0]) === null || ref1 === void 0 ? void 0 : ref1.message : "No existe un usuario registrado con ese email.");
                    }
                    setLoading(false);
                    setIsSent(true);
                });
            }
        }
    });
    // console.log("ForgotPasswordForm ", resetKey);
    var values = formik.values, setFieldValue = formik.setFieldValue, handleSubmit = formik.handleSubmit, errors = formik.errors;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "ab-forgot-password",
        children: isSent ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    element: "h3",
                    children: formTitle || t("titleForgot")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    children: t("emailSent")
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
            onSubmit: handleSubmit,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    element: "h3",
                    children: formTitle || t("titleForgot")
                }),
                values.key ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_input__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            placeholder: t("password"),
                            value: values.password,
                            onChange: function(val) {
                                return setFieldValue("password", val);
                            },
                            type: "password",
                            error: errors.password
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_input__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            placeholder: t("passwordConfirm"),
                            value: values.passwordConfirm,
                            onChange: function(val) {
                                return setFieldValue("passwordConfirm", val);
                            },
                            type: "password",
                            error: errors.passwordConfirm
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_input__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    placeholder: emailPlaceholder || t("email"),
                    value: values.email,
                    onChange: function(val) {
                        return setFieldValue("email", val);
                    }
                }),
                error ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: error
                }) : null,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_form_button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    loading: loading,
                    children: t("button")
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ForgotPassword);


/***/ }),

/***/ 81402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var ook_loading__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27336);
/* harmony import */ var _ab_form_button_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73969);
/* harmony import */ var _ab_form_button_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_ab_form_button_scss__WEBPACK_IMPORTED_MODULE_2__);






var FormButton = function(_param) {
    var loading = _param.loading, children = _param.children, onClick = _param.onClick, disabled = _param.disabled, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "loading",
        "children",
        "onClick",
        "disabled"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: "ab-form-button",
        type: "submit",
        onClick: onClick,
        disabled: loading || disabled
    }, rest), {
        children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ook_loading__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            loading: true,
            mini: true
        }) : children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (FormButton);


/***/ }),

/***/ 9215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var ab_text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(145);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _ab_input_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78015);
/* harmony import */ var _ab_input_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ab_input_scss__WEBPACK_IMPORTED_MODULE_3__);







var Input = function(_param) {
    var _type = _param.type, type = _type === void 0 ? "text" : _type, value = _param.value, onChange = _param.onChange, className = _param.className, label = _param.label, placeholder = _param.placeholder, error = _param.error, parentClassName = _param.parentClassName, placeHolderClassname = _param.placeHolderClassname, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "type",
        "value",
        "onChange",
        "className",
        "label",
        "placeholder",
        "error",
        "parentClassName",
        "placeHolderClassname"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), showPassword = ref[0], setShowPassword = ref[1];
    var renderInput = function() {
        if (parentClassName == "at-novartis") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                        className: "ab-input".concat(className ? " ".concat(className) : "").concat(error ? " error" : ""),
                        type: type,
                        value: value,
                        onChange: function(e) {
                            return onChange(e.target.value);
                        },
                        placeholder: placeholder
                    }, rest)),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                        className: "ab-input".concat(className ? " ".concat(className) : "").concat(error ? " error" : ""),
                        type: type,
                        value:  true ? "@novartis.com" : 0,
                        placeholder: placeholder
                    }, rest), {
                        disabled: true
                    }))
                ]
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            className: "ab-input".concat(className ? " ".concat(className) : "").concat(error ? " error" : "", " ").concat(placeHolderClassname || ""),
            type: showPassword ? "text" : type,
            value: value,
            onChange: function(e) {
                return type !== "checkbox" && type !== "radio" ? onChange(e.target.value) : onChange(e.target.checked);
            },
            checked: value,
            placeholder: placeholder
        }, rest));
    };
    // if (type == "text" || type == "password") {
    //   return renderInput();
    // }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        className: "ab-input container ".concat(type, " ").concat(parentClassName),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                children: label
            }),
            renderInput(),
            type == "password" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "password",
                role: "button",
                onClick: function() {
                    return setShowPassword(!showPassword);
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: showPassword ? "/images/hide.png" : "/images/show.png",
                    style: {
                        width: 16,
                        height: 16
                    },
                    alt: showPassword ? "hide" : "show"
                })
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "checkmark"
            }),
            error ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "error",
                children: error
            }) : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 70996:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 73969:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 78015:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9200,9774,2888,179], function() { return __webpack_exec__(61196); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);